import React from 'react'

const UndoIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
        <path
            d="M5.59999 16.7999V15.5999H16.4C18.38 15.5999 20 13.9799 20 11.9999C20 10.0199 18.38 8.3999 16.4 8.3999H7.99999V10.1999L3.85999 7.7999L7.99999 5.3999V7.1999H16.4C19.04 7.1999 21.2 9.3599 21.2 11.9999C21.2 14.6399 19.04 16.7999 16.4 16.7999H5.59999Z"
            fill="#333333"
        />
    </svg>
)

export default UndoIcon
